import { Invoice } from 'src/app/shared/models/invoice';
import { Component, OnInit } from '@angular/core';
import { CompaniesService } from 'src/app/shared/services/companies.service';
import { UtilitiesService } from 'src/app/shared/services/utilities.service';
import { Company } from 'src/app/shared/models/companies';
import { Subscription } from 'rxjs';
import { Level } from '../../shared/enums/level.enum';

@Component({
  selector: 'app-invoice',
  templateUrl: './invoice.component.html',
  styleUrls: ['./invoice.component.scss']
})
export class InvoiceComponent implements OnInit {

  public invoices: Invoice[];
  public companies: {id: string, companyName: string}[];
  _subscriptions: Subscription[] = [];
  usdt: any;
  companiesList: Company[] = [];
  public filters: any;

  constructor(
    private utilitiesService: UtilitiesService,
    public companiesService: CompaniesService) { 
      this.filters= { 
        id: '',
        dateStart: new Date(), 
        dateEnd: new Date()
      };
      this.usdt = this.utilitiesService.getUserData();
      switch (this.usdt.level) {
        case Level.ihunterSuperUser:
          this._subscriptions.push(
            this.companiesService.getCompanies().subscribe(
              (res: any) => {
                console.log(res);
                this.companies = res;
                this.companies.unshift({id: '0', companyName: 'Todos'});
              },
              error => {
                console.log(error);
            }),
            this.utilitiesService.getInvoices().subscribe(invoices=>{
              this.invoices = invoices;
            })
          );
          break;
        case Level.ihunterAdmin:
          this._subscriptions.push(
            companiesService.getCompanies().subscribe(companies => {
                this.companiesList = companies;
            })
          );
          break;
        case Level.ihunterReportes:
          this._subscriptions.push(
            companiesService.getCompanies().subscribe(companies => {
                this.companiesList = companies;
            })
          );
          break;
        case Level.Broker:
          break;
          default:
            break;
      }
  }

  ngOnInit(): void {
  }

  getInvoices(e){
    this.utilitiesService.getInvoicesCompany(this.filters.companyId).subscribe(invoices=>{
        this.invoices=invoices;
    });
  }

  downloadPdfInvoice(idInvoice){
    this.utilitiesService.downloadPdfInvoice(idInvoice).subscribe(result =>{
      console.log(result);
      
      const source = `data:application/pdf;base64,${result.Content}`;
      const link = document.createElement("a");
      link.href = source;
      link.download = `factura.pdf`
      link.click();
    });
  }

  downloadXmlInvoice(idInvoice){
    this.utilitiesService.downloadXmlInvoice(idInvoice).subscribe(result =>{
    console.log(result);
    
    const source = `data:application/xml;base64,${result.Content}`;
    const link = document.createElement("a");
    link.href = source;
    link.download = `factura.xml`
    link.click();
  });
}
}
